export enum ControlLevelValidatorType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  STRING = 'STRING',
  TIME = 'TIME',
}
